import React from 'react';
import Chart from './Chart';

const BarChart = (props) => <Chart type="bar" {...props} />;

export default BarChart;
